/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Go_To_ProfileInputs */



/**
* | output |
* | --- |
* | "Go to Profile" |
*
* @param {Community_Go_To_ProfileInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_go_to_profile = /** @type {((inputs?: Community_Go_To_ProfileInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Go_To_ProfileInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aller au profil")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ir al perfil")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ir para o perfil")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai al profilo")
	return /** @type {LocalizedString} */ ("Go to Profile")
});